import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const UpdateSettingsSlc = createSlice({
  name: "updatesettings",
  initialState,
  reducers: {
    requestStart(state) {
      state.loading = true;
      state.error = null;
    },
    requestSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    requestFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { requestStart, requestSuccess, requestFailure } =
  UpdateSettingsSlc.actions;

export default UpdateSettingsSlc.reducer;

export const Updatesettings = (formValues) => async (dispatch) => {
  try {
    dispatch(requestStart());
    await axios
      .put("/private/settings", formValues)
      .then((respo) => {
        // toast.success("Please Check your inbox.");
        dispatch(requestSuccess(respo?.data));
        // navigate.push("/dashboard");
      })
      .catch((err) => {
        toast.error(err);
        dispatch(requestFailure(err));
      });
  } catch (error) {
    dispatch(requestFailure(error?.response?.data || "Something went wrong!"));
    toast.error(error?.response?.data || "Something went wrong!");
  }
};
